module.exports = __webpack_public_path__ + "media/images/pic/testimonials/awatar-04-89823589c24005ee5af1dd5d2f19a342.svg";